export default "__VITE_ASSET__CYABJ9tB__"